module.exports = "<div class=\"agent-bonus-tooltip\">\n    <div class=\"agent-bonus-tooltip__header\">Бонус по успешной сделке</div>\n    <div class=\"agent-bonus-tooltip__body\">{$ agentBonusTooltip == 'developer' ? 'Застройщик' : 'Агент' $} указал, что готов поделиться своей комиссией в рамках указанного бонуса</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/agent-bonus/tooltip.html
// module id = 519
// module chunks = 0